<div class="calendar-outer admin-calendar-outer">
  <div class="calendar-outer-ui-scrollpanel-x">
    <div class="cal-week-view" role="grid">

      <!-- ── COLUMN HEADERS ──────────────────────────────────────────────────── -->
      <div class="cal-day-headers" role="row">
        <div class="cal-header"></div>
        <div class="cal-header" *ngFor="let user of users; trackBy: trackById" tabindex="0" role="columnheader">
          <div class="calendar-header-outer-box">
            <div class="calendar-header-outer-box__right">
              <p-checkbox name="groupname{{ user.id }}" binary="true" [(ngModel)]="user.isChecked"
                (onChange)="addToSelectedHeader($event, user.field, user.id)"></p-checkbox>
            </div>
            <div class="calendar-header-outer-box__left">
              <strong pTooltip="{{ user.name }}">{{ user.name }}</strong>
              <ng-container *ngIf="isGroupAppointmentFeatureSubscribed">
              <svg *ngIf="user.isGroupAppointmentUser" width="17" height="15" viewBox="0 0 17 15" fill="none"
                xmlns="http://www.w3.org/2000/svg" style="margin-left: auto;">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M9.35 8.82353C10.2517 8.82353 11.1165 9.19538 11.7542 9.85727C12.3918 10.5192 12.75 11.4169 12.75 12.3529V14.1176C12.75 14.3517 12.6604 14.5761 12.501 14.7416C12.3416 14.907 12.1254 15 11.9 15C11.6746 15 11.4584 14.907 11.299 14.7416C11.1396 14.5761 11.05 14.3517 11.05 14.1176V12.3529C11.05 11.8849 10.8709 11.4361 10.5521 11.1051C10.2333 10.7742 9.80087 10.5882 9.35 10.5882H3.4C2.94913 10.5882 2.51673 10.7742 2.19792 11.1051C1.87911 11.4361 1.7 11.8849 1.7 12.3529V14.1176C1.7 14.3517 1.61045 14.5761 1.45104 14.7416C1.29163 14.907 1.07543 15 0.85 15C0.624566 15 0.408365 14.907 0.248959 14.7416C0.0895533 14.5761 0 14.3517 0 14.1176V12.3529C0 11.4169 0.358213 10.5192 0.995837 9.85727C1.63346 9.19538 2.49826 8.82353 3.4 8.82353H9.35ZM14.45 8.82353C15.1263 8.82353 15.7749 9.10242 16.2531 9.59883C16.7313 10.0953 17 10.7685 17 11.4706V13.2353C17 13.4693 16.9104 13.6937 16.751 13.8592C16.5916 14.0247 16.3754 14.1176 16.15 14.1176C15.9246 14.1176 15.7084 14.0247 15.549 13.8592C15.3896 13.6937 15.3 13.4693 15.3 13.2353V11.4706C15.3 11.2366 15.2104 11.0121 15.051 10.8467C14.8916 10.6812 14.6754 10.5882 14.45 10.5882H13.2464C12.9524 9.88914 12.4888 9.28112 11.9009 8.82353H14.45ZM6.375 0C7.38945 0 8.36236 0.418329 9.07968 1.16296C9.79701 1.90759 10.2 2.91752 10.2 3.97059C10.2 5.02365 9.79701 6.03359 9.07968 6.77822C8.36236 7.52285 7.38945 7.94118 6.375 7.94118C5.36055 7.94118 4.38764 7.52285 3.67032 6.77822C2.95299 6.03359 2.55 5.02365 2.55 3.97059C2.55 2.91752 2.95299 1.90759 3.67032 1.16296C4.38764 0.418329 5.36055 0 6.375 0ZM13.6 2.64706C14.2763 2.64706 14.9249 2.92594 15.4031 3.42236C15.8813 3.91878 16.15 4.59207 16.15 5.29412C16.15 5.99616 15.8813 6.66945 15.4031 7.16587C14.9249 7.66229 14.2763 7.94118 13.6 7.94118C12.9237 7.94118 12.2751 7.66229 11.7969 7.16587C11.3187 6.66945 11.05 5.99616 11.05 5.29412C11.05 4.59207 11.3187 3.91878 11.7969 3.42236C12.2751 2.92594 12.9237 2.64706 13.6 2.64706ZM6.375 1.76471C5.81142 1.76471 5.27091 1.99711 4.8724 2.41079C4.47388 2.82448 4.25 3.38555 4.25 3.97059C4.25 4.55562 4.47388 5.1167 4.8724 5.53038C5.27091 5.94407 5.81142 6.17647 6.375 6.17647C6.93859 6.17647 7.47909 5.94407 7.8776 5.53038C8.27612 5.1167 8.5 4.55562 8.5 3.97059C8.5 3.38555 8.27612 2.82448 7.8776 2.41079C7.47909 1.99711 6.93859 1.76471 6.375 1.76471ZM13.6 4.41176C13.3746 4.41176 13.1584 4.50473 12.999 4.6702C12.8396 4.83567 12.75 5.0601 12.75 5.29412C12.75 5.52813 12.8396 5.75256 12.999 5.91804C13.1584 6.08351 13.3746 6.17647 13.6 6.17647C13.8254 6.17647 14.0416 6.08351 14.201 5.91804C14.3604 5.75256 14.45 5.52813 14.45 5.29412C14.45 5.0601 14.3604 4.83567 14.201 4.6702C14.0416 4.50473 13.8254 4.41176 13.6 4.41176Z"
                  fill="#868686" />
              </svg>
              <i *ngIf="!user.isGroupAppointmentUser" class="pi pi-user" style="font-size: 2rem;color: #64748b;margin-left: auto;"></i>
              </ng-container>
            </div>

            <span *ngFor="let avail of user.distinctTherapistAvailability" class="facilityName"
              (click)="GetAvailability(user.id, $event, availpopup, user.name)">
              <span pTooltip="{{ avail.facilityName }}">{{ avail.facilityName }}</span>
              <small *ngIf="avail.facilityTimeZone !== ''">&nbsp;({{ avail.facilityTimeZone | timezone }})</small>
            </span>
          </div>
          <p-overlayPanel class="availpopup" styleClass="availpopup" appendTo="body" #availpopup>
            <div class="availpopup__block">
              <div class="availpopup__block__top">
                <strong>Today's Availability</strong> {{ viewDate | date : appDateFormat.dateFormat }}
              </div>
              <div class="availpopup__block__middle" *ngFor="let item of availModel">
                <a href="#">
                  <strong>{{ item.crmStartTime | date : 'shortTime' | lowercase }} - {{ item.crmEndTime | date : 'shortTime' | lowercase }}</strong>
                  {{ item.isRemoteAndFacility ? item.facilityName + ' & ' + item.remoteFacilityName : item.facilityName }}
                </a>
              </div>
              <div class="availpopup__block__btn">
                <button class="btn btn--primary" type="button" (click)="showAvail(user.enUserInfoId)">View Month Availability</button>
              </div>
            </div>
          </p-overlayPanel>
        </div>
      </div>

      <!-- ── ALL-DAY EVENTS ──────────────────────────────────────────────────── -->
      <div class="cal-all-day-events" #allDayEventsContainer *ngIf="view.allDayEventRows.length > 0"
        mwlDroppable (dragEnter)="dragEnter('allDay')" (dragLeave)="dragLeave('allDay')">
        <div class="cal-day-columns">
          <div class="cal-time-label-column" [ngTemplateOutlet]="allDayEventsLabelTemplate"></div>
          <div class="cal-day-column" *ngFor="let day of days; trackBy: trackByWeekDayHeaderDate"
            mwlDroppable dragOverClass="cal-drag-over"
            (drop)="eventDropped($event, day.date, true)" (dragEnter)="dateDragEnter(day.date)"></div>
        </div>
        <div *ngFor="let eventRow of view.allDayEventRows; trackBy: trackById" #eventRowContainer class="cal-events-row">
          <div *ngFor="let allDayEvent of eventRow.row; trackBy: trackByWeekAllDayEvent" #event
            class="cal-event-container"
            [class.cal-draggable]="allDayEvent.event.draggable && allDayEventResizes.size === 0"
            [class.cal-starts-within-week]="!allDayEvent.startsBeforeWeek"
            [class.cal-ends-within-week]="!allDayEvent.endsAfterWeek"
            [ngClass]="allDayEvent.event?.cssClass"
            [style.width.%]="(100 / users.length) * allDayEvent.span"
            [style.marginLeft.%]="(100 / users.length) * allDayEvent.offset"
            mwlDraggable dragActiveClass="cal-drag-active"
            [dropData]="{ event: allDayEvent.event, calendarId: calendarId }"
            [dragAxis]="{ x: allDayEvent.event.draggable && allDayEventResizes.size === 0,
                          y: !snapDraggedEvents && allDayEvent.event.draggable && allDayEventResizes.size === 0 }"
            [dragSnapGrid]="snapDraggedEvents ? { x: dayColumnWidth } : {}"
            [validateDrag]="validateDrag"
            (dragStart)="dragStarted(eventRowContainer, event, null, null)"
            (dragging)="allDayEventDragMove()"
            (dragEnd)="dragEnded(allDayEvent, $event, dayColumnWidth)">
            <mwl-calendar-week-view-event [locale]="locale" [weekEvent]="allDayEvent"
              [tooltipPlacement]="tooltipPlacement" [tooltipTemplate]="tooltipTemplate"
              [tooltipAppendToBody]="tooltipAppendToBody" [tooltipDelay]="tooltipDelay"
              [customTemplate]="eventTemplate" [eventTitleTemplate]="eventTitleTemplate"
              [eventActionsTemplate]="eventActionsTemplate" [daysInWeek]="daysInWeek"
              (eventClicked)="eventClicked.emit({ event: allDayEvent.event, sourceEvent: $event.sourceEvent })">
            </mwl-calendar-week-view-event>
          </div>
        </div>
      </div>

      <!-- ── TIME EVENTS ─────────────────────────────────────────────────────── -->
      <div class="cal-time-events" mwlDroppable (dragEnter)="dragEnter('time')" (dragLeave)="dragLeave('time')"
        [style.width.px]="getcalenderColumnWidth()">
        <div class="cal-time-label-column" *ngIf="view.hourColumns.length > 0">
          <div *ngFor="let hour of view.hourColumns[0].hours; trackBy: trackByHour; let odd = odd"
            class="cal-hour" [class.cal-hour-odd]="odd">
            <mwl-calendar-week-view-hour-segment
              *ngFor="let segment of hour.segments; trackBy: trackByHourSegment"
              [style.height.px]="hourSegmentHeight" [segment]="segment"
              [segmentHeight]="hourSegmentHeight" [locale]="locale"
              [customTemplate]="customHourSegmentTemplate" [isTimeLabel]="true">
            </mwl-calendar-week-view-hour-segment>
          </div>
        </div>

        <div class="cal-day-columns" [class.cal-resize-active]="timeEventResizes.size > 0" #dayColumns>
          <div class="cal-day-column" *ngFor="let column of view.hourColumns; let i = index; trackBy: trackByHourColumn">

            <div *ngFor="let timeEvent of column.events; trackBy: trackByWeekTimeEvent"
              #event class="cal-event-container"
              [class.cal-starts-within-day]="!timeEvent.startsBeforeDay"
              [class.cal-ends-within-day]="!timeEvent.endsAfterDay"
              [ngClass]="timeEvent.event.cssClass"
              [hidden]="timeEvent.height === 0 && timeEvent.width === 0"
              [style.top.px]="timeEvent.top" [style.height.px]="timeEvent.height"
              mwlResizable
              [resizeSnapGrid]="{ left: dayColumnWidth, right: dayColumnWidth,
                                  top: eventSnapSize || hourSegmentHeight, bottom: eventSnapSize || hourSegmentHeight }"
              [validateResize]="validateResize" [allowNegativeResizes]="true"
              (resizeStart)="timeEventResizeStarted(dayColumns, timeEvent, $event)"
              (resizing)="timeEventResizing(timeEvent, $event)"
              (resizeEnd)="timeEventResizeEnded(timeEvent)"
              mwlDraggable dragActiveClass="cal-drag-active"
              [dropData]="{ event: timeEvent.event, calendarId: calendarId }"
              [dragAxis]="{ x: timeEvent.event.draggable && timeEventResizes.size === 0,
                            y: timeEvent.event.draggable && timeEventResizes.size === 0 }"
              [dragSnapGrid]="snapDraggedEvents ? { x: dayColumnWidth, y: eventSnapSize || hourSegmentHeight } : {}"
              [ghostDragEnabled]="!snapDraggedEvents" [validateDrag]="validateDrag"
              (dragStart)="dragStarted(dayColumns, event, timeEvent, null)"
              (dragging)="dragMove(timeEvent, $event)"
              (dragEnd)="dragEnded(timeEvent, $event, dayColumnWidth, true)">

              <mwl-calendar-week-view-event [locale]="locale" [weekEvent]="timeEvent"
                [tooltipPlacement]="tooltipPlacement" [tooltipTemplate]="tooltipTemplate"
                [tooltipAppendToBody]="tooltipAppendToBody"
                [tooltipDisabled]="dragActive || timeEventResizes.size > 0"
                [tooltipDelay]="tooltipDelay" [customTemplate]="eventTemplate"
                [eventTitleTemplate]="timeEvent.event.id == 0 ? customBreakHours
                                    : timeEvent.event.id == -1 ? customBlockHours
                                    : customTitleTemplate"
                [eventActionsTemplate]="eventActionsTemplate" [column]="column">
              </mwl-calendar-week-view-event>

              <div class="cal-resize-handle cal-resize-handle-after-end"
                *ngIf="timeEvent.event?.resizable?.afterEnd && !timeEvent.endsAfterDay"
                mwlResizeHandle [resizeEdges]="{ right: true, bottom: true }"></div>
            </div>

            <div *ngFor="let hour of column.hours; trackBy: trackByHour; let odd = odd"
              class="cal-hour" [class.cal-hour-odd]="odd">
              <mwl-calendar-week-view-hour-segment
                *ngFor="let segment of hour.segments; trackBy: trackByHourSegment"
                [style.height.px]="hourSegmentHeight"
                [segment]="view.users[i]"
                [segmentHeight]="hourSegmentHeight"
                [locale]="segment"
                [customTemplate]="idDateIsPassed(segment.date, view.users[i]) ? customHourSegmentTemplate1 : customHourSegmentTemplate2"
                (mwlClick)="hourSegmentClickedOverrite(segment.date, $event, view.users[i])"
                mwlDroppable
                [dragOverClass]="!dragActive || !snapDraggedEvents ? 'cal-drag-over' : null"
                dragActiveClass="cal-drag-active"
                (drop)="eventDropped($event, segment.date, false)">
              </mwl-calendar-week-view-hour-segment>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>


<!-- ════════════════════════════════════════════════════════════════════════════
     REUSABLE CARD CONTENT TEMPLATE
     Extracted so the same markup serves both normal (≥15 min) and half-slot
     cards without duplication.

     Context variables expected:
       event        – the CalendarEvent passed by mwl-calendar-week-view-event
     ════════════════════════════════════════════════════════════════════════════ -->

<!-- ── SHARED CARD INNER BLOCK ──────────────────────────────────────────────── -->
<!--
  We create one ng-template for the card body and stamp it twice (normal / 15-min).
  All reactive fields go through helper methods that read from the ACTIVE event:
    - getActiveStartLabel(event)       → time row start
    - getActiveEndLabel(event)         → time row end
    - getActivePatientTimeZone(event)  → timezone suffix
    - getActiveClassification(event)   → classification badge
    - getActiveSalesOrderAppId(event)  → SO# link
    - getActivePatientRcmId(event)     → P# link
    - getActivePatientId(event)        → P# display value
    - getActivePatientName(event)      → <h6> patient name
    - getActiveAppointmentType(event)  → ngClass colour bands
    - getActiveFacilityName(event)     → facility / location icon
    - getActivePatientAddress(event)   → address (Home Visit)
-->

<!-- ── NORMAL SLOT (≥ 15 min) ─────────────────────────────────────────────── -->
<ng-template #customTitleTemplate let-event="event" let-view="view">

  <div *ngIf="event.id != 0 && event.id != -1 && !event.is15minSlot"
      [ngClass]="[
      event.meta.appointmentInfoReponseModel.isMoveStart ? 'move-highlighted'
        : getActiveBookedBy(event) == 0
          ? 'calendar-box book-by-patient' : 'calendar-box done',
      getActiveAppointmentType(event) === 'Facility Visit' ? 'calendar-box facility-slot'  : 'calendar-box',
      getActiveAppointmentType(event) === 'Telehealth'     ? 'calendar-box remote-slot'    : 'calendar-box',
      getActiveAppointmentType(event) === 'Home Visit'     ? 'calendar-box road-home-slot' : 'calendar-box'
    ]">
    <span class="patient-color"></span>

    <!-- ── TIME ROW ───────────────────────────────────────────────────────── -->
    <!--
      For group appointments the time shown is the ACTIVE patient's time slot.
      getActiveStartLabel / getActiveEndLabel / getActivePatientTimeZone
      all read from the selected patient's event object.
    -->
    <div class="calendar-box__time-zone">
      <span class="time">
        {{ getActiveStartLabel(event) | date : 'shortTime' | lowercase }}
        - {{ getActiveEndLabel(event) | date : 'shortTime' | lowercase }}
        | {{ getActivePatientTimeZone(event) | timezone }}
      </span>
      <p-checkbox name="group2" value="{{ event.id }}" [(ngModel)]="selectedRowAppointment"
        (onChange)="addToSelectedAppointment($event, event)"></p-checkbox>
    </div>

    <div class="calendar-box__title">
      <div class="calendar-box__title__box">

        <!-- Classification — reactive to active patient -->
        <span class="classification" pTooltip="{{ getActiveClassification(event) }}">
          {{ getActiveClassification(event) }}
        </span>

        <!-- SO# / P# — reactive to active patient -->
        <span class="classification">
          SO#<a href="javascript:void(0)"
            (click)="onNavigateBrightTreeSalesOrderUrl(getActiveSalesOrderAppId(event))">
            {{ getActiveSalesOrderAppId(event) }}
          </a>
          |
          <span class="bright-tree-patient-url">
            P#<a href="javascript:void(0)"
              (click)="onNavigateBrightTreePatientUrl(getActivePatientRcmId(event))">
              {{ getActivePatientId(event) }}
            </a>
          </span>
        </span>

        <h6 pTooltip="{{ getActivePatientName(event) }}">{{ getActivePatientName(event) }}</h6>

        <span class="address-box" *ngIf="getActiveAppointmentType(event) === 'Home Visit'">
          {{ getActivePatientAddress(event) }}
        </span>
        <div class="therapist-group-option" *ngIf="isGroupAppointment(event)">
          <span class="therapist-group-option__list">
            <p-select
              class="form__dropdown select-box"
              [options]="getGroupPatients(event.appointmentGroupId)"
              [ngModel]="getSelectedPatientOption(event.appointmentGroupId)"
              (ngModelChange)="onGroupPatientChange($event, event.appointmentGroupId)"
              optionLabel="name"
              [filter]="false"
              appendTo="body"
              (click)="$event.stopPropagation()">
            </p-select>
          </span>
          <span class="therapist-group-option__count">
            ({{ getGroupPatients(event.appointmentGroupId).length }}/{{event?.maxAppointmentsInGroup}})
          </span>
        </div>
      </div>
    </div>

    <div class="calendar-box__click-box">
      <div class="calendar-box__edit-delete" *ngIf="isFutureDate(event.start)">
        <a href="javascript:void(0)" (click)="showDialogPopupForEvent(event)" class="dots-btn">
          <svg width="21" height="5" viewBox="0 0 21 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="2.5"  cy="2.5" r="2.5" fill="#707070"></circle>
            <circle cx="10.5" cy="2.5" r="2.5" fill="#707070"></circle>
            <circle cx="18.5" cy="2.5" r="2.5" fill="#707070"></circle>
          </svg>
        </a>
      </div>

      <span *ngIf="getActiveAppointmentType(event) !== 'Home Visit'"
        class="calendar-box__facility-name"
        pTooltip="{{ getActiveFacilityName(event) }}">
        {{ getActiveFacilityName(event) }}
      </span>
      <i *ngIf="getActiveAppointmentType(event) === 'Home Visit'"
        class="location-icon"
        pTooltip="{{ getActiveFacilityName(event) }}"></i>

      <small class="time" *ngIf="event.meta.appointmentInfoReponseModel.isCallStart">
        Call in Progress....
      </small>
    </div>
  </div>


  <!-- ── 15-MIN (HALF) SLOT ─────────────────────────────────────────────────── -->
  
  <div class="calendar-box done half-slot"
    *ngIf="event.id != 0 && event.id != -1 && event.is15minSlot"
        [ngClass]="[
      event.meta.appointmentInfoReponseModel.isMoveStart ? 'move-highlighted'
        : getActiveBookedBy(event) == 0
          ? 'calendar-box book-by-patient' : 'calendar-box done',
      getActiveAppointmentType(event) === 'Facility Visit' ? 'calendar-box facility-slot'  : 'calendar-box',
      getActiveAppointmentType(event) === 'Telehealth'     ? 'calendar-box remote-slot'    : 'calendar-box',
      getActiveAppointmentType(event) === 'Home Visit'     ? 'calendar-box road-home-slot' : 'calendar-box'
    ]">
    <span class="patient-color"></span>

    <!-- Time row — reactive -->
    <div class="calendar-box__time-zone">
      <span class="time">
        {{ getActiveStartLabel(event) | date : 'shortTime' | lowercase }}
        - {{ getActiveEndLabel(event) | date : 'shortTime' | lowercase }}
        | {{ getActivePatientTimeZone(event) | timezone }}
      </span>
      <p-checkbox name="group2" value="{{ event.id }}" [(ngModel)]="selectedRowAppointment"
        (onChange)="addToSelectedAppointment($event, event)"></p-checkbox>
    </div>

    <!-- Title block — reactive -->
    <div class="calendar-box__title">
      <div class="calendar-box__title__box">

        <span class="classification" pTooltip="{{ getActiveClassification(event) }}">
          {{ getActiveClassification(event) }}
        </span>

        <span class="classification">
          SO#<a href="javascript:void(0)"
            (click)="onNavigateBrightTreeSalesOrderUrl(getActiveSalesOrderAppId(event))">
            {{ getActiveSalesOrderAppId(event) }}
          </a>
          |
          <span class="bright-tree-patient-url">
            P#<a href="javascript:void(0)"
              (click)="onNavigateBrightTreePatientUrl(getActivePatientRcmId(event))">
              {{ getActivePatientId(event) }}
            </a>
          </span>
        </span>

        <h6 *ngIf="!isGroupAppointment(event)" pTooltip="{{ getActivePatientName(event) }}">{{ getActivePatientName(event) }}</h6>

        <!-- Home Visit address — reactive -->
        <i *ngIf="getActiveAppointmentType(event) === 'Home Visit'"
          class="location-icon"
          pTooltip="{{ getActivePatientAddress(event) }}"></i>

        <!-- Group dropdown (15-min slot) — same wiring as normal slot -->
        <div class="therapist-group-option" *ngIf="isGroupAppointment(event)">
          <span class="therapist-group-option__list">
            <p-select
              class="form__dropdown select-box"
              [options]="getGroupPatients(event.appointmentGroupId)"
              [ngModel]="getSelectedPatientOption(event.appointmentGroupId)"
              (ngModelChange)="onGroupPatientChange($event, event.appointmentGroupId)"
              optionLabel="name"
              [filter]="false"
              appendTo="body"
              (click)="$event.stopPropagation()">
            </p-select>
          </span>
          <span class="therapist-group-option__count">
            ({{ getGroupPatients(event.appointmentGroupId).length }}/{{event?.maxAppointmentsInGroup}})
          </span>
        </div>

      </div>
    </div>

    <!-- Bottom action row (15-min) -->
    <div class="calendar-box__click-box">
      <div class="calendar-box__edit-delete" *ngIf="isFutureDate(event.start)">
        <a href="javascript:void(0)" (click)="showDialogPopupForEvent(event)" class="dots-btn">
          <svg width="21" height="5" viewBox="0 0 21 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="2.5"  cy="2.5" r="2.5" fill="#707070"></circle>
            <circle cx="10.5" cy="2.5" r="2.5" fill="#707070"></circle>
            <circle cx="18.5" cy="2.5" r="2.5" fill="#707070"></circle>
          </svg>
        </a>
      </div>
      <span *ngIf="getActiveAppointmentType(event) !== 'Home Visit'"
        class="calendar-box__facility-name"
        pTooltip="{{ getActiveFacilityName(event) }}">
        {{ getActiveFacilityName(event) }}
      </span>
      <i *ngIf="getActiveAppointmentType(event) === 'Home Visit'"
        class="location-icon"
        pTooltip="{{ getActiveFacilityName(event) }}"></i>
      <small class="time" *ngIf="event.meta.appointmentInfoReponseModel.isCallStart">
        Call in Progress....
      </small>
    </div>
  </div>

</ng-template>


<!-- ── BLOCK HOURS TEMPLATE (unchanged) ──────────────────────────────────────── -->
<ng-template #customBlockHours let-event="event" let-view="view">
  <div [ngClass]="event.isBlock ? 'calendar-box is-block' : 'calendar-box not-available'" *ngIf="event.id == -1">
    <span class="patient-color"></span>
    <div class="calendar-box__time-zone">
      <span class="time">
        {{ event.startLabel | date : 'shortTime' | lowercase }} -
        {{ event.endLabel   | date : 'shortTime' | lowercase }} |
        {{ event.facilityTimeZone | timezone }}
      </span>
    </div>
    <div class="calendar-box__title">
      <h6 pTooltip="{{ event.title }}">{{ event.title }}</h6>
    </div>
    <div class="calendar-box__click-box" *ngIf="event.isBlock && isFutureDate(event.start) && !event?.isSystemBlock">
      <div class="calendar-box__edit-delete">
        <a href="javascript:void(0)" class="remove-block-calendar" pTooltip="Edit Block" tooltipPosition="top"
          (click)="editSlot(event.therapistCustomAvailabilityId, event.availId, event.therapistCustomDateId)">
          <i class="edit-icon-new"></i>
        </a>
        <a href="javascript:void(0)" class="remove-block-calendar" pTooltip="Remove Block" tooltipPosition="top"
          (click)="removeSlot(event.therapistCustomAvailabilityId, event.availId, event.customDatesId)">
          <i class="delete-icon-new"></i>
        </a>
      </div>
    </div>
  </div>
</ng-template>


<!-- ── BREAK HOURS TEMPLATE (unchanged) ──────────────────────────────────────── -->
<ng-template #customBreakHours let-event="event" let-view="view">
  <div class="calendar-box done break-hours">
    <span class="patient-color"></span>
    <div class="calendar-box__time-zone">
      <span class="time">
        {{ event.startLabel | date : 'shortTime' | lowercase }} -
        {{ event.endLabel   | date : 'shortTime' | lowercase }} |
        {{ event.facilityTimeZone | timezone }}
      </span>
    </div>
    <div class="calendar-box__title">
      <h6>{{ event.title }}</h6>
    </div>
    <div class="calendar-box__click-box" *ngIf="isFutureDate(event.start)">
      <div class="calendar-box__edit-delete">
        <a href="javascript:void(0)" class="remove-block-calendar" pTooltip="Edit Break" tooltipPosition="top"
          (click)="editBreak(event.therapistCustomAvailabilityId, event.availId, event.therapistCustomDateId)">
          <i class="edit-icon-new"></i>
        </a>
        <a href="javascript:void(0)" class="remove-block-calendar" pTooltip="Remove Break" tooltipPosition="top"
          (click)="removeBreak(event.therapistCustomAvailabilityId, event.availId, event.customDatesId)">
          <i class="delete-icon-new"></i>
        </a>
      </div>
    </div>
  </div>
</ng-template>


<!-- ── HOUR SEGMENT TEMPLATES (unchanged) ────────────────────────────────────── -->
<ng-template #customHourSegmentTemplate let-segment="segment" let-locale="locale">
  <div class="cal-cell-top" [class.cal-hour-start]="segment.isStart"
    [class.cal-after-hour-start]="!segment.isStart" [ngClass]="segment.cssClass">
    <div class="cal-time">{{ segment.date | date : 'shortTime' : locale }}</div>
  </div>
</ng-template>

<ng-template #customHourSegmentTemplate1 let-segment="segment" let-locale="locale" let-user="user">
  <div class="fill-slot" *ngIf="facilityNameLabel(locale.date, segment.therapistAvailability)">
    <a class="last-box__add-btn" href="javascript:void(0)">
      <img src="assets/img/facility-ic.svg" width="29" alt="down-arrow" />
      <strong pTooltip="{{ facilityNameLabel(locale.date, segment.therapistAvailability) }}">
        {{ facilityNameLabel(locale.date, segment.therapistAvailability) }}
      </strong>
    </a>
  </div>
  <div *ngIf="facilityNameLabel(locale.date, segment.therapistAvailability) == ''"
    class="fill-slot not-available" style="background-color: #f9f9f9 !important; text-align: center">
    N/A
  </div>
</ng-template>

<ng-template #customHourSegmentTemplate2 let-segment="segment" let-locale="locale">
  <div class="fill-slot" style="background-color: #f9f9f9 !important; text-align: center">N/A</div>
</ng-template>